var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"per-avatar-area"},[_c('img',{staticClass:"per-avatar",attrs:{"src":_vm.avatarUrl(_vm.user.id || _vm.user.uId, _vm.user.headId),"alt":"","loading":"lazy","onerror":_vm.defaultAvatar}})])}
var staticRenderFns = []

export { render, staticRenderFns }